/**
 * @Date:   2019-10-21T15:06:21+05:30
 * @Last modified time: 2019-10-21T15:24:33+05:30
 */

import { put, takeLatest } from "redux-saga/effects";
import { setInspectedReferral } from "./referralInspect";
import { openCardDetailModal } from "./cardDetailModal";
import { enqueueSnackbar } from "./notifiers";
import _ from "lodash";
import { DONE_STATE } from "../../constants/referrals";
import { updateReferralInArray } from "../../utils/arrays";

// Actions
const CHANGE_REFERRAL_STATE = "hermes/referrals-received/CHANGE_REFERRAL_STATE";
const CHANGE_REFERRAL_STATE_SUCCESS =
  "hermes/referrals-received/CHANGE_REFERRAL_STATE_SUCCESS";
const CHANGE_REFERRAL_STATE_FAILURE =
  "hermes/referrals-received/CHANGE_REFERRAL_STATE_FAILURE";
const TOGGLE_REFERRAL_FLAG_SUCCESS =
  "hermes/referrals-received/TOGGLE_REFERRAL_FLAG_SUCCESS";
const TOGGLE_REFERRAL_FLAG_RESET =
  "hermes/referrals-received/TOGGLE_REFERRAL_FLAG_RESET";
export const EDIT_REFERRAL_SUCCESS =
  "hermes/referrals-received/EDIT_REFERRAL_SUCCESS";
const GET_RECEIVED_REFERRALS_SUCCESS =
  "hermes/referrals-received/GET_RECEIVED_REFERRALS_SUCCESS";
const GET_RECEIVED_REFERRAL = "hermes/referrals-received/GET_RECEIVED_REFERRAL";
const GET_RECEIVED_REFERRAL_SUCCESS =
  "hermes/referrals-received/GET_RECEIVED_REFERRAL_SUCCESS";
const SELECT_ASSIGNEE = "hermes/referrals-received/SELECT_ASSIGNEE";
const LOADING_START = "hermes/referrals-received/LOADING_START";
const LOADING_FINISH = "hermes/referrals-received/LOADING_FINISH";
const CLEAR_REFERRAL_ACTION_COMMENT =
  "hermes/referrals-received/CLEAR_REFERRAL_ACTION_COMMENT";
const RESET_REFRESH_FLAG = "hermes/referrals-sent/RESET_REFRESH_FLAG";

const initialState = {
  list: [],
  details: [],
  loaded: false,
  referralFlagToggledId: null,
  referralActionComment: "",
  referralStatus: "",
  refreshReferralSearch: false,
  loading: false,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_RECEIVED_REFERRALS_SUCCESS:
      return {
        ...state,
        list: action.response,
        loaded: true,
      };
    case GET_RECEIVED_REFERRAL_SUCCESS:
      const getReceivedDetails = _.cloneDeep(state.details);
      const detailExists = state.details.findIndex(
        (referral) =>
          action.processInstanceId === referral.id ||
          action.response?.id === referral.id
      );
      if (detailExists !== -1) {
        getReceivedDetails[detailExists] = action.response;
      } else {
        getReceivedDetails.push(action.response);
      }
      return {
        ...state,
        details: getReceivedDetails,
      };
    case CHANGE_REFERRAL_STATE:
      let updatedDetails = [];
      const referralDetailIndex = state.details.findIndex(
        (referral) => action.referralId === referral.id
      );

      if (referralDetailIndex !== -1) {
        updatedDetails = [...state.details];
        updatedDetails[referralDetailIndex] = {
          ...updatedDetails[referralDetailIndex],
          status: action.targetState,
        };
      }

      return {
        ...state,
        list:
          state.list.length > 0
            ? updateReferralInArray(state.list, action.referralId, {
                status: action.targetState,
              })
            : state.list,
        details: updatedDetails,
      };
    case CHANGE_REFERRAL_STATE_SUCCESS:
      let referralActionComment = "";
      let successUpdatedDetails = [];

      const referralDetailSuccessIndex = state.details.findIndex(
        (referral) => action.referral?.id === referral.id
      );

      if (referralDetailSuccessIndex !== -1) {
        successUpdatedDetails = [...state.details];
        successUpdatedDetails[referralDetailSuccessIndex] = {
          ...successUpdatedDetails[referralDetailSuccessIndex],
          status: action.newStatus,
        };
      }

      if (action.referral.status === DONE_STATE && action.referral.comment) {
        referralActionComment = action.referral.comment;
      }

      return {
        ...state,
        referralActionComment,
        referralStatus: action.newStatus,
        list:
          state.list.length > 0
            ? updateReferralInArray(
                state.list,
                action.referral.id,
                action.referral
              )
            : state.list,
        details: successUpdatedDetails,
        refreshReferralSearch: true,
      };
    case CLEAR_REFERRAL_ACTION_COMMENT:
      return {
        ...state,
        referralActionComment: "",
      };
    case CHANGE_REFERRAL_STATE_FAILURE:
      const changeStateFailDetail = _.cloneDeep(state.details);
      const changeStateFailDetailExists = state.details.findIndex(
        (referral) =>
          action.processInstanceId === referral.id ||
          action.referral?.id === referral.id
      );
      if (changeStateFailDetailExists !== -1) {
        changeStateFailDetail[changeStateFailDetailExists] = action.referral;
      }
      return {
        ...state,
        list: [
          ...state.list.map((referral) => {
            if (action.referral.id === referral.id) {
              return action.referral;
            }
            return referral;
          }),
        ],
        details: changeStateFailDetail,
      };
    case EDIT_REFERRAL_SUCCESS:
      const editDetail = _.cloneDeep(state.details);
      const editDetailExists = state.details.findIndex(
        (referral) =>
          action.processInstanceId === referral.id ||
          action.referral?.id === referral.id
      );
      if (editDetailExists !== -1) {
        editDetail[editDetailExists] = {
          ...(editDetail[editDetailExists].patientId ===
            action.referral.patientId && {
            patient: editDetail[editDetailExists].patient,
          }),
          ...action.referral,
        };
      }
      return {
        ...state,
        list: state.list.map((ref) => {
          if (ref.id === action.referral.id) {
            return {
              ...(ref.patientId === action.referral.patientId && {
                patient: ref.patient,
              }),
              ...action.referral,
            };
          }
          return ref;
        }),
        details: editDetail,
      };
    case TOGGLE_REFERRAL_FLAG_SUCCESS: {
      const referralId = action.id;
      const newFlaggedState = action.flagged;

      // Update list referrals
      const updatedList = state.list.map((ref) =>
        ref.id === referralId ? { ...ref, flagged: newFlaggedState } : ref
      );

      // Update details referrals only if fullScreen is true
      const updatedDetails = action.fullScreen
        ? state.details.map((ref) =>
            ref.id === referralId ? { ...ref, flagged: newFlaggedState } : ref
          )
        : state.details;

      return {
        ...state,
        referralFlagToggledId: action.referralId,
        list: updatedList,
        details: updatedDetails,
      };
    }
    case TOGGLE_REFERRAL_FLAG_RESET:
      return {
        ...state,
        referralFlagToggledId: null,
      };
    case LOADING_START:
      return {
        ...state,
        loading: true,
      };
    case LOADING_FINISH:
      return {
        ...state,
        loading: false,
      };
    case RESET_REFRESH_FLAG:
      return {
        ...state,
        refreshReferralSearch: false,
      };
    default:
      return state;
  }
}

// Action Creators
export function changeReferralState(referralId, targetState) {
  return {
    type: CHANGE_REFERRAL_STATE,
    referralId,
    targetState,
  };
}

export function changeReferralStatusSuccess(referral, newStatus) {
  return {
    type: CHANGE_REFERRAL_STATE_SUCCESS,
    referral,
    newStatus,
  };
}

export function resetReceivedRefresh() {
  return { type: RESET_REFRESH_FLAG };
}

export function toggleReceivedReferralFlagSuccess(
  referralId,
  flagged,
  fullScreen = false
) {
  return {
    type: TOGGLE_REFERRAL_FLAG_SUCCESS,
    id: referralId,
    flagged: !flagged,
    fullScreen,
  };
}

export function clearReferralActionComment() {
  return {
    type: CLEAR_REFERRAL_ACTION_COMMENT,
  };
}

export function getReceivedReferralsApollo(data) {
  return {
    type: GET_RECEIVED_REFERRALS_SUCCESS,
    response: data,
  };
}

export function startApolloLoading() {
  return { type: LOADING_START };
}

export function finishApolloLoading() {
  return { type: LOADING_FINISH };
}

export function getReceivedReferral(referral, options = {}) {
  const { inspectReferral, cardDetail } = options;
  return {
    type: GET_RECEIVED_REFERRAL,
    referral,
    inspectReferral,
    cardDetail,
  };
}

export function resetReceiveReferralFlag() {
  return {
    type: TOGGLE_REFERRAL_FLAG_RESET,
  };
}

export function selectAssignee(referralId, displayableId, assignee) {
  return {
    type: SELECT_ASSIGNEE,
    referralId,
    displayableId,
    assignee,
  };
}

// Sagas
function* handleGetReceivedReferral(action) {
  try {
    let response = action?.referral;
    response = { ...response };
    response.inNetwork = null;
    yield put({
      response,
      type: GET_RECEIVED_REFERRAL_SUCCESS,
    });
    if (action.inspectReferral) {
      yield put(setInspectedReferral(response));
    }
    if (action.cardDetail) {
      yield put(openCardDetailModal(response));
    }
  } catch (e) {
    if (action.inspectReferral) {
      yield put(setInspectedReferral(null));
    }
    yield put(
      enqueueSnackbar({
        message: `Unable to fetch referral.`,
        options: {
          variant: "error",
        },
      })
    );
  }
}

export function* getReceivedReferralSaga() {
  yield takeLatest(GET_RECEIVED_REFERRAL, handleGetReceivedReferral);
}
